var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 15.4183C8.5 16.0031 8.05 16.4816 7.5 16.4816C6.95 16.4816 6.5 16.0031 6.5 15.4183V11.1651C6.5 10.5803 6.95 10.1018 7.5 10.1018C8.05 10.1018 8.5 10.5803 8.5 11.1651V15.4183ZM14.5 15.4183C14.5 16.0031 14.05 16.4816 13.5 16.4816C12.95 16.4816 12.5 16.0031 12.5 15.4183V11.1651C12.5 10.5803 12.95 10.1018 13.5 10.1018C14.05 10.1018 14.5 10.5803 14.5 11.1651V15.4183ZM16.5 18.6082C16.5 19.194 16.052 19.6715 15.5 19.6715H5.5C4.948 19.6715 4.5 19.194 4.5 18.6082V6.91197H16.5V18.6082ZM8.5 3.00757C8.5 2.84276 8.714 2.65881 9 2.65881H12C12.286 2.65881 12.5 2.84276 12.5 3.00757V4.78539H8.5V3.00757ZM19.5 4.78539H18.5H14.5V3.00757C14.5 1.6423 13.379 0.532227 12 0.532227H9C7.621 0.532227 6.5 1.6423 6.5 3.00757V4.78539H2.5H1.5C0.95 4.78539 0.5 5.26387 0.5 5.84868C0.5 6.43349 0.95 6.91197 1.5 6.91197H2.5V18.6082C2.5 20.3669 3.846 21.798 5.5 21.798H15.5C17.154 21.798 18.5 20.3669 18.5 18.6082V6.91197H19.5C20.05 6.91197 20.5 6.43349 20.5 5.84868C20.5 5.26387 20.05 4.78539 19.5 4.78539Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.de2849995af072aa3cafd8ab65580181.svg";
export { ForwardRef as ReactComponent };